<app-top-level-menu [class.show]="userMenuService.showTopLevelMenu()"></app-top-level-menu>
<div class="header-button" (click)="openFeedback()" #feedbackButton>
	<app-icon name="community" size="large" color="typography-4"></app-icon>
</div>
<div class="header-button" (click)="openHelp()">
	<app-icon name="help" size="large" color="typography-4"></app-icon>
</div>

@if (!urlService.isBeheer()) {
	<div class="header-button" (click)="openBookmark()" #bookmarkButton>
		<app-icon name="bookmark" size="large" color="typography-4"></app-icon>
	</div>
}
<app-profiel-menu></app-profiel-menu>
